import './introView.css';
//import logo_stb from '../img/logo-stb.png';
import logo_stb_white from '../img/logo-stb-white.png';
import img_activities_1 from '../img/img-activities-1.jpg';
import img_activities_2 from '../img/img-activities-2.jpg';
import img_activities_3 from '../img/img-activities-3.jpg';
import { useState, useEffect, useRef } from 'react';
import BouncingBall from './BouncingBall';
import HorizontalTicker from './HorizontalTicker';

function IntroView() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const introRef = useRef(null);
    const containerRef = useRef(null);
    const [isRotating, setIsRotating] = useState(false);

    const [tileCount, setTileCount] = useState(20);

useEffect(() => {
    const updateTileCount = () => {
        const width = window.innerWidth;
        let count;

        if (width < 500) {
            count = 5;
        } else if (width < 1000) {
            count = 15;
        } else if (width < 1500) {
            count = 20;
        } else if (width < 2000) {
            count = 30;
        } else {
            count = 30;
        }

        setTileCount(count);
    };

    updateTileCount();
    window.addEventListener('resize', updateTileCount);
    return () => window.removeEventListener('resize', updateTileCount);
}, []);




    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    // 初回マウント時に高さを固定設定
    useEffect(() => {
        const vh = window.innerHeight * 1;
        const maxHeight = 1500; // 最大高さを800pxに設定

        if (introRef.current) {
            const calculatedHeight = Math.min(vh - 40, maxHeight);
            introRef.current.style.height = `${calculatedHeight}px`;
        }
    }, []);

    return (
        <div className={`App-intro ${isMenuOpen ? 'open' : ''}`} ref={introRef}>
            <header className="App-header">
                <a href="/">
                    <img src={logo_stb_white} alt="logo-Science_Tokyo_Biz" className="icon-header" />
                </a>
                <div className="menu-button" onClick={toggleMenu}>
                    <div className={`menu-line top ${isMenuOpen ? 'open' : ''}`}></div>
                    <div className={`menu-text ${isMenuOpen ? 'open' : ''}`}>
                        {isMenuOpen ? '× close' : 'menu'}
                    </div>
                    <div className={`menu-line bottom ${isMenuOpen ? 'open' : ''}`}></div>
                </div>
                <nav className={`menu ${isMenuOpen ? 'open' : ''}`}>
                    <ul>
                        <li><a href="#vision" onClick={() => setIsMenuOpen(false)}>Vision</a></li>
                        <li><a href="#events" onClick={() => setIsMenuOpen(false)}>Events</a></li>
                        <li><a href="#interviews" onClick={() => setIsMenuOpen(false)}>Interview</a></li>
                        <li><a href="#partners" onClick={() => setIsMenuOpen(false)}>Partners</a></li>
                        <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
                    </ul>
                </nav>
            </header>

            <div className="background-wrapper">
                <div className='bouncingball-container'>
                    <BouncingBall />
                </div>
                <div className="first-view-layer">
                    <div className="firstview-container" ref={containerRef}>
                        {Array.from({ length: tileCount }, (_, i) => (
                            <div
                                className={`glass-column ${isRotating ? 'rotating' : ''}`}
                                key={i}
                                onAnimationEnd={() => {
                                    if (i === 0) setIsRotating(false);
                                }}
                            >
                                {i === tileCount - 1 ? (
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setIsRotating(true);
                                        }}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            fontSize: '2rem',
                                            cursor: 'pointer',
                                            color: '#0c419b',
                                        }}
                                    >
                                    </button>
                                ) : null}
                            </div>
                        ))}
                    </div>
                </div>
                
                <div className="first-view-box">
                    <div className="horizontal-bar">
                        <HorizontalTicker />
                    </div>
                </div>
                <div className='overlay'>
                    <div className="overlay-text">
                        <h1>
                            ビジネス・起業に挑む東京科学大生、<br />ここに集結。
                        </h1>
                        <h3 className='overlay-text-sub'>
                            東京科学大学の各機関と連携し、<br />
                            ビジネス・起業に興味を持つ学生が<br />
                            最初に訪れる場を提供します。
                        </h3>
                    </div>
                    <div className="overlay-fig">
                        <img className="center-img" src={img_activities_1} alt="Main" />
                        <img className="top-left-img" src={img_activities_2} alt="Top Right" />
                        <img className="bottom-right-img" src={img_activities_3} alt="Bottom Left" />
                        
                    </div>
                </div>
                <div className="scroll-down-icon">
                    <span>Scroll ↓ Down</span>
                </div>
            </div>
        </div>
    );
}

export default IntroView;
